export const PROFILE_LOGIN_IFRAME_NAME = 'login-iframe';

export const PROFILE_LOGIN_PATH = '/iframe-auth/login/';

export const PROFILE_REGISTRATION_PATH = '/iframe-auth/registration/';

export const PROFILE_LOGIN_DATA_PATH = '/api/ajax/client/login-data';

export const PROFILE_DEPOSIT_PATH = '/iframe/funds/deposit';
